import { useQuery } from "@tanstack/react-query";
import { userService } from "@/services/userService";

export const hodKeys = {
  all: ['hod'],
  list: (page, searchParams) => [...hodKeys.all, 'list', page, searchParams],
};

export const useHOD = (page = 1, searchParams = {}) => {
  return useQuery({
    queryKey: hodKeys.list(page, searchParams),
    queryFn: async () => {
      try {
        const response = await userService.getheadOfDepartment(page, searchParams);
        
        // Check if response.data exists and extract the correct data
        const headOfDepartments = response.data || response;
        
        const allUsers = await userService.getAllUsers();
        const users = allUsers.data || allUsers;

        // Check if headOfDepartments.users exists, if not use headOfDepartments.data
        const hodUsers = headOfDepartments.users || headOfDepartments.data || [];
        
        const advisorsWithAssignedUsers = Array.isArray(hodUsers) 
          ? hodUsers.map(head => {
              const assignedUsers = users.filter(user => user.assigned_to === head.id);
              return {
                ...head,
                assignedUsers
              };
            }) 
          : [];

        // Return both the HODs and pagination data with proper fallbacks
        return {
          data: advisorsWithAssignedUsers,
          pagination: {
            current_page: headOfDepartments.pagination?.current_page || headOfDepartments.current_page || 1,
            total: headOfDepartments.pagination?.total || headOfDepartments.total || advisorsWithAssignedUsers.length,
            per_page: headOfDepartments.pagination?.per_page || headOfDepartments.per_page || 10,
            last_page: headOfDepartments.pagination?.last_page || headOfDepartments.last_page || Math.ceil(advisorsWithAssignedUsers.length / 10)
          }
        };
      } catch (error) {
        console.error("Error in useHOD hook:", error);
        throw error;
      }
    },
    keepPreviousData: true // Keep displaying previous data while new data is fetched
  });
}; 